var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'nuxt-class-component';
import { Prop, Watch } from 'vue-property-decorator';
var Model = (function (_super) {
    __extends(Model, _super);
    function Model() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = _this.value;
        return _this;
    }
    Model.prototype.onValue = function (val) {
        this.data = this.value;
    };
    Model.prototype.onData = function (val) {
        this.$emit('input', val);
    };
    __decorate([
        Prop({ required: false })
    ], Model.prototype, "value", void 0);
    __decorate([
        Watch('value')
    ], Model.prototype, "onValue", null);
    __decorate([
        Watch('data')
    ], Model.prototype, "onData", null);
    Model = __decorate([
        Component
    ], Model);
    return Model;
}(Vue));
export default Model;



//////////////////
// WEBPACK FOOTER
// ./mixins/model.ts
// module id = ./mixins/model.ts
// module chunks = 2 4 5 6 7 8 12 13 16